import { Component, TemplateRef, viewChild } from '@angular/core';


@Component({
    selector: 'soft-page-summary',
    imports: [],
    templateUrl: './page-summary.component.html',
    styleUrl: './page-summary.component.css'
})
export class PageSummaryComponent {
  template = viewChild(TemplateRef);
}
